<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// eslint-disable-next-line
import { version } from "../package.json"

export default {
  name: 'App',
}

</script>

<style>

</style>
